import React from "react";
import { graphql } from "gatsby";
import Layout from "../components/Layout";
import PopularPosts from "../components/PopularPosts";
import "./post.css";
import Facebook from "../images/facebook.png";
import Twitter from "../images/twitter.png";

export default ({ data, location }) => {
  const { post, popular } = data || {};
  const { frontmatter, html } = post || {};
  const { title, featured_image: featuredImage, date } = frontmatter || {};

  return (
    <Layout>
      <h1 className="title">{title}</h1>
      <img src={featuredImage} alt={title} className="featured-image" />
      <div className="post-container">
        <p className="date">{date}</p>
        <div className="post" dangerouslySetInnerHTML={{ __html: html }} />
        <div className="social">
          <p>Share Post:</p>
          <a
            href={`https://www.facebook.com/sharer/sharer.php?href=${location.href}`}
            target="_blank"
          >
            <img
              src={Facebook}
              alt="Share to Facebook"
              className="share-icon"
            />
          </a>
          <a
            href={`https://www.twitter.com/intent/tweet/?text=${title}&url=${location.href}`}
            target="_blank"
          >
            <img src={Twitter} alt="Share to Twitter" className="share-icon" />
          </a>
        </div>
      </div>
      <div className="read-more">
        <h2>Read More...</h2>
        <PopularPosts posts={popular} />
      </div>
    </Layout>
  );
};
export const query = graphql`
  query ($slug: String!) {
    post: markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
        featured_image
        date
      }
    }
    popular: allMarkdownRemark(
      filter: { frontmatter: { featured_post: { eq: true } } }
      limit: 3
    ) {
      edges {
        node {
          excerpt
          frontmatter {
            date
            title
            featured_image
          }
          fields {
            slug
          }
        }
      }
    }
  }
`;
